import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCaretDoubleRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M5.5 8 2 4.5 3.5 3l5 5-5 5L2 11.5z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M11.5 8 8 4.5 9.5 3l5 5-5 5L8 11.5z"
	})]
});
export default SvgCaretDoubleRight;
